import moment from 'moment';
import { ESnapshotExists, ENotice, EOrganization } from 'lib/types';
import { Badge } from 'lib/components/Badge';
import { Tooltip } from 'lib/components/Tooltip';
import { getDeadlineString } from 'lib/utils/deadlines';
import { EyeSlashIcon, EyeIcon } from '@heroicons/react/24/outline';

type DeadlineStatusBadgeProps = {
  publicationMoment: moment.Moment;
  notice: ESnapshotExists<ENotice>;
  newspaper: ESnapshotExists<EOrganization>;
  ignoreDisplayOffset: boolean;
};

export function DeadlineStatusBadge({
  publicationMoment,
  notice,
  newspaper,
  ignoreDisplayOffset
}: DeadlineStatusBadgeProps) {
  const { deadlines, deadlineOverrides = {} } = newspaper.data();
  const publicationDeadlineString = getDeadlineString(
    deadlines,
    deadlineOverrides,
    publicationMoment.toDate(),
    notice.data(),
    newspaper,
    undefined,
    ignoreDisplayOffset
  );

  const helpText = ignoreDisplayOffset
    ? 'Deadline without display offset'
    : 'Deadline with display offset';

  return (
    <Tooltip helpText={helpText}>
      <div className="cursor-pointer">
        <Badge
          // status={ignoreDisplayOffset ? 'success' : undefined}
          startIcon={
            ignoreDisplayOffset ? (
              <EyeIcon className="w-4 h-4" />
            ) : (
              <EyeSlashIcon className="w-4 h-4" />
            )
          }
          size="lg"
        >
          {publicationDeadlineString}
        </Badge>
      </div>
    </Tooltip>
  );
}
